import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Target } from 'lucide-react';
import { type Campaign } from './types';
import { CondensedCampaignRow } from './CondensedCampaignRow';
import { formatDate } from './utils';

interface CampaignOverviewTabProps {
    campaigns: Campaign[];
    recentActivity: Campaign[];
    onTabChange: (tab: string) => void;
    onEdit?: (campaignId: string) => void;
    onView?: (campaignId: string) => void;
    onDelete?: (campaignId: number) => void;
    onGenerateBrief?: (campaign: Campaign) => void;
    isGeneratingBrief?: boolean;
    generatingBriefCampaignId?: number;
    canEdit?: boolean;
    canDelete?: boolean;
}

export function CampaignOverviewTab({
 campaigns,
    recentActivity,
    onTabChange,
    onEdit,
    onDelete,
    onView,
    onGenerateBrief,
    isGeneratingBrief,
    generatingBriefCampaignId,
    canEdit,
    canDelete
}: CampaignOverviewTabProps) {
    return (
        <div className="space-y-6">
       <div className="space-y-4">
                <div className="flex items-center justify-between">
  <h3 className="font-semibold text-lg text-gray-900">Recent Campaigns</h3>
      <Button
   variant="ghost"
      size="sm"
 onClick={() => onTabChange('list')}
         className="text-sm text-blue-600 hover:text-blue-700"
     >
             View All ?
    </Button>
     </div>
 <div className="space-y-3">
         {campaigns.length > 0 ? (
   campaigns.slice(0, 5).map((campaign) => (
                        <CondensedCampaignRow
                            key={campaign.id}
                            campaign={campaign}
                            onEdit={onEdit}
                            onView={onView}
                            onDelete={onDelete}
                            onGenerateBrief={onGenerateBrief}
                            isGeneratingBrief={isGeneratingBrief}
                            generatingBriefCampaignId={generatingBriefCampaignId}
                            canEdit={canEdit}
    canDelete={canDelete}
       />
             ))
        ) : (
            <div className="text-center py-12 bg-white border border-gray-200 rounded-lg">
     <Target className="w-12 h-12 mx-auto text-gray-300 mb-3" />
          <p className="text-gray-500">No campaigns found for the selected filters.</p>
           <p className="text-sm text-gray-400 mt-1">Try adjusting your filters or create a new campaign.</p>
     </div>
             )}
          </div>

    <div className="space-y-4">
   <h3 className="font-semibold text-lg text-gray-900">Recent Activity</h3>
    <div className="bg-white border border-gray-200 rounded-lg divide-y divide-gray-100">
               {recentActivity.length > 0 ? (
     recentActivity.slice(0, 5).map((campaign) => (
        <div key={campaign.id} className="flex items-center justify-between p-4 hover:bg-gray-50 transition-colors">
  <div className="flex items-center gap-3 min-w-0 flex-1">
   <div className={`w-2 h-2 rounded-full flex-shrink-0 ${
 campaign.status === 'active' ? 'bg-green-500' :
        campaign.status === 'upcoming' ? 'bg-blue-500' :
              'bg-gray-500'
            }`}></div>
   <div className="min-w-0 flex-1">
        <p className="font-medium text-sm text-gray-900 truncate">{campaign.name}</p>
 <p className="text-xs text-gray-500 truncate">
              {campaign.businessUnit} • {campaign.category}
        </p>
       </div>
       </div>
     <div className="flex items-center gap-3 flex-shrink-0">
 <Badge
variant="secondary"
             className={`text-xs ${
 campaign.status === 'active' ? 'bg-green-100 text-green-800' :
 campaign.status === 'upcoming' ? 'bg-blue-100 text-blue-800' :
  'bg-gray-100 text-gray-800'
           }`}
     >
           {campaign.campaignType}
      </Badge>
           <span className="text-xs text-gray-400">
     {formatDate(campaign.startDate)}
             </span>
          </div>
     </div>
          ))
             ) : (
     <div className="text-center py-8 text-gray-500">
         <p>No recent activity found.</p>
<p className="text-xs mt-1">Campaign updates will appear here.</p>
</div>
    )}
         </div>
        </div>
            </div>
        </div>
    );
}
